import { Component } from '@angular/core';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router'; // Add this import
import { MobileHeaderComponent } from '../components/mobile-header/mobile-header.component';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { SidebarUserComponent } from "../components/sidebar-user/sidebar-user.component";
import { getCookie } from '../utils/getCookies';
@Component({
  selector: 'app-dashboard-main',
  standalone: true,
  imports: [SidebarComponent, RouterModule, MobileHeaderComponent, CommonModule, SidebarUserComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {

  constructor(private router: Router) { } 
  
  image: any = localStorage.getItem('profile_image_company');
  currentProfileImageUrl: string = this.image ? environment.url + "/" + this.image  : "assets/anonimo.jpg";  // Replace with your current profile image URL or logic to fetch it // Replace with your current profile image URL or logic to fetch it
  companyName: any = getCookie('company_name');
  isCompanyLoggedIn: boolean = this.companyName !== 'undefined' && this.companyName !== null && this.companyName !== ''; 
}
